<div class="flex flex-col w-full relative">
    <p class="text-start font-bold text-[#0D7167] mb-2">{{ lable }}</p>

    <highcharts-chart
        id="container"
        [Highcharts]="Highcharts"
        [options]="options"
    >
    </highcharts-chart>
</div>
